<script setup>
import { computed } from 'vue'
import PageHeader from './PageHeader.vue'
import AemFooter from '@/components/organisms/layout/AemFooter.vue'
import SideNav from './SideNav.vue'
import { useWebAppStore } from '@/stores/webApp'
import { i18nService } from '@accor/customer-vue-services'
import { isWebView } from '@accor/customer-core'
import { useDimension } from '@/composables/useDimension'

const webAppStore = useWebAppStore()
const { headerNavHeight } = useDimension()

const locale = computed(() => i18nService.getCurrentLocale())
const isLocaleDefined = computed(() => locale.value !== 'xx')
const navTop = computed(() => `${headerNavHeight.value}px`)
const navMaxHeight = computed(() => `calc(100vh - ${headerNavHeight.value}px)`)
</script>

<template>
  <div class="page-layout">
    <PageHeader v-if="isLocaleDefined && !isWebView()" />

    <div
      class="page-layout__content"
      :class="{
        'page-layout__content--hide-nav': !webAppStore.navIsDisplayed,
        'page-layout__content--container': !webAppStore.sideNavDisplayIsAllowed
      }"
    >
      <SideNav v-if="isLocaleDefined" class="page-layout__nav" />
      <div class="page-layout__main">
        <slot />
      </div>
    </div>

    <AemFooter v-if="isLocaleDefined && !isWebView()" />
  </div>
</template>
<style lang="scss">
.page-layout {
  @include ads-sass.ads-breakpoint('small') {
    grid-template-columns: 1fr;

    &__nav {
      display: none;
    }
  }

  &__content {
    display: grid;
    align-items: start;
    grid-template-columns: 320px 1fr;
  }

  &__nav {
    position: sticky;
    top: v-bind(navTop);
    display: block;
    max-height: v-bind(navMaxHeight);
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: ads.$ads-outline-low transparent;
  }
}
</style>
